import { SkeletonWebElementBase } from './SkeletonWebElementBase';

/**
 * The component WebElement for [oj-c-skeleton](../../jsdocs/oj-c.Skeleton.html).
 * Do not instantiate this class directly, instead, use
 * [findSkeleton](../functions/findSkeleton.html).
 */
export class SkeletonWebElement extends SkeletonWebElementBase {
  // Put overrides here
}
